import React, { Component } from 'react';
import { Upload, message, DatePicker, Button, Icon } from 'antd';
import moment from "moment";

const { MonthPicker } = DatePicker;

class index extends Component {
    state = {
        loading: false,
        fileList: []
    }
    render() {
        const { date, loading, fileList } = this.state;
        const that = this;
        const props = {
            name: 'file',
            action: '/openDateExcel',
            accept: ".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            headers: {
                authorization: 'authorization-text',
            },
            fileList,
            onChange(info) {
                that.setState({ fileList: [info.file], loading: true });
                if (info.file.status === 'done') {
                    if (info.file.response.status == 1) {
                        message.success(`${date} 数据已经更新成功！`);
                    } else {
                        message.error(`${date} 更新失败，请重新上传或联系管理员！`);
                    }
                    that.setState({ loading: false, });
                    return
                } else if (info.file.status === 'error') {
                    message.error(`表格上传失败！`);
                    that.setState({ loading: false, });
                }
            },
        };
        return (
            <div className="list">
                <div className="title">
                    酒店开业日期、合同到期时间导入
                </div>
                <Upload {...props}>
                    <Button
                        loading={loading}
                    >
                        <Icon type="upload" /> {loading ? '文件上传中。。。' : "上传"}
                    </Button>
                </Upload>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/guestReviewImport/Contract.js